/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { AppHeaderSettingLinkViewerFragmentDoc } from './AppHeaderSettingLink.generated';
export type DefaultAppHeaderQueryFragment = { viewer: { profile: { name: string, avatar: any }, staff: { email: string } } };

export const DefaultAppHeaderQueryFragmentDoc = gql`
    fragment DefaultAppHeaderQuery on Query {
  viewer {
    ...AppHeaderSettingLinkViewer
  }
}
    ${AppHeaderSettingLinkViewerFragmentDoc}`;